import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";

import Modal from "../../ui/Modals/ModalWindow";
import TemplateForm from "../../ui/TemplateForm/TemplateForm";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import {
  createTemplateAsync,
  clearTemplateForm,
} from "../../../redux/actions/editTemplate";

import {
  openCancelModal,
  closeCancelModal,
} from "../../../redux/actions/ui";

const mapStateToProps = state => ({
  ...state.editTemplate,
  cancelModal: state.ui.cancelModal,
});

const mapDispatchToProps = dispatch => ({
  openCancelModal: () => dispatch(openCancelModal()),
  closeCancelModal: () => dispatch(closeCancelModal()),
  onGoBack: () => dispatch(push('/templates')),
  onCreateTemplate: () => dispatch(createTemplateAsync()),
  clearForm: () => dispatch(clearTemplateForm()),
});

class CreateTemplate extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    template: PropTypes.object.isRequired,
    onGoBack: PropTypes.func.isRequired,
    cancelModal: PropTypes.object.isRequired,
    openCancelModal: PropTypes.func.isRequired,
    closeCancelModal: PropTypes.func.isRequired,
    onCreateTemplate: PropTypes.func.isRequired,
    clearForm: PropTypes.func.isRequired,
  };

  formIsEmpty = () => {
    const { template } = this.props;
    if (
      (template.name.length === 0) //Название не меняли
      && (template.thumbnail === null) //Картинку не загружали
      && (!template.is_default) //Значение по умолчанию не меняли
    ) return true; 
    return false;
  }

  askOrGoBack = () => {
    const { template, openCancelModal, onGoBack } = this.props;
    this.formIsEmpty(template) ? onGoBack() : openCancelModal();
  }

  closeModalAndGo = () => {
    const { closeCancelModal, onGoBack, clearForm } = this.props;
    closeCancelModal();
    clearForm();
    onGoBack();
  }

  render() {
    const {
      ready,
      loading,
      cancelModal,
      closeCancelModal,
      onCreateTemplate,
    } = this.props;

    return (
      <div className="page-wrapper">
        <Modal
          confirmText="Остаться"
          cancelText="Покинуть страницу"
          modal={cancelModal}
          onSubmit={() => closeCancelModal()}
          onCancel={() => this.closeModalAndGo()}
        />
        <div className="page-header">
          {ready ? (
            <button type="button" className="btn btn-back" onClick={() => this.askOrGoBack()}>
              <i aria-hidden="true" className="back-icon icon" />
              <span>Назад</span> 
            </button>
          ) : false}
        </div>
        <div className="page-content forms">
          <div className="form-header">Создание шаблона</div>
          {ready ? (
            <TemplateForm
              submitText="Создать шаблон"
              onSubmit={() => onCreateTemplate()}
            />
          ) : false}
          {loading ? (<Spinner />) : false}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(CreateTemplate));
